import DOMPurify from 'isomorphic-dompurify';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd } from 'next-seo';

import { replaceWithRequiredSiteInfo } from '@/helper/wordReplace';
import { SITE_TITLE, SITE_URL } from '@/utils/constants';

import BreadCrumbs from '../breadcrumbs/breadcrumb';
import { generateDynamicBCLD } from '../utility';

const TitleDescriptionComponent = (props: any) => {
  const title = props?.title;
  const desc = props?.description;
  const router = useRouter();
  const pathWithoutQuery = router.asPath.split('?')[0];
  const isBreadCrumb: any = props?.isBread || false;
  const { hostUrl } = props;
  const brandUrl = hostUrl ? `https://${hostUrl}` : SITE_URL;
  const brandTitle = SITE_TITLE;
  const breadCrumbUrlList = generateDynamicBCLD(router);
  const descriptionStyle = props?.descriptionStyle || null;
  return (
    <div className="sv-page-content TnC-wrapper blog-detail-wrapper">
      {isBreadCrumb && (
        <div className="my-4">
          <BreadCrumbs path={pathWithoutQuery} />
          <BreadcrumbJsonLd itemListElements={breadCrumbUrlList} />
        </div>
      )}
      <div className="container">
        <h1 className="section-heading shadow-none mb-3">{title}</h1>
        <div className="user-agreement blog-banner">
          <div className="row">
            <div
              className={`col-lg-12 col-md-12 col-sm-12 ${descriptionStyle}`}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  replaceWithRequiredSiteInfo(brandTitle, brandUrl, desc)
                ),
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TitleDescriptionComponent;
